<template>
  <div class="menus-content">
    <div v-show="showMenus" class="mask">
      <div class="wrapper" @click.stop>
        <div class="block" >
          <div class="item-content" id="item-content">
            <van-checkbox-group v-model="result" class="box" id="div">
              <van-checkbox class="checkbox-item" v-for="item in params" :key="item.id" :name="item">{{item.name}}</van-checkbox>
            </van-checkbox-group>
          </div>
          <p>
            <van-button type="info" size="small" @click="selectedSystem">确定</van-button>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'dropMenus',
  props: ['params', 'showMenus'],
  data () {
    return {
      result: []
    }
  },
  mounted () {
  },
  methods: {
    selectedSystem () {
      this.$emit('parentData', this.result)
    }
  }
}
</script>

<style scoped lang="scss">
    .menus-content{
      .mask{
        z-index: 1;
        width: 100%;
        height: 100%;
        position: fixed;
        top: 0;
        left: 0;
        background: rgba(0, 0, 0, 0.7);
      }
      .wrapper {
          display: flex;
          align-items: flex-end;
          justify-content: center;
          height: 100%;
      }
      .block {
          z-index: 2;
          width: 100%;
          height: 40%;
          background-color: #fff;
          overflow-y: scroll;
          padding-bottom: 80px;
          margin-bottom: 20px;
          p{
              text-align: right;
              padding-top: 10px;
              position: fixed;
              bottom: 0px;
              left: 0;
              background-color: #fff;
              width: 100%;
              padding-bottom: 20px;
              button{
                  margin-right: 20px;
              }
          }
          .checkbox-item{
              padding: 10px 0;
              margin: 0 16px;
              height: 26px;
              border-bottom: 1px solid #cccccc;
              line-height: 26px;
          }
        .item-content{
          height: auto;
        }
      }
    }
</style>



// WEBPACK FOOTER //
// src/components/dropCheckbox.vue